import React, { memo } from 'react'

import { func } from 'prop-types'

function UploadPrompt({ onBrowseClick }) {
  return (
    <>
      <span className="image-uploader__title">
        Drop your image here or{' '}
        <a className="cgt-legacy-link image-uploader__link" onClick={onBrowseClick}>
          browse
        </a>
      </span>
      <span className="image-uploader__subtitle">
        PNG, JPG, WEBP
      </span>
    </>
  )
}

UploadPrompt.propTypes = {
  onBrowseClick: func.isRequired,
}

export default memo(UploadPrompt)
